// Bundle Selector Script - Version: 2024-12-19-v3
// This script handles the bundle selection functionality for Polar Dive products

document.addEventListener('DOMContentLoaded', function () {
  var isInitialLoad = true;

  // Listen for variant changes to update modal content
  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      isInitialLoad = false;
      // Update modal after variant change (product-info.js updates it first, then we override)
      setTimeout(function () {
        updateModalFromGallery();
      }, 350);
    });
  }
  var tubCards = document.querySelectorAll('#tub-options .bundle-card');
  var chillerToggle = document.querySelectorAll('#chiller-toggle .bundle-card');
  var chillerDetails = document.getElementById('chiller-details');
  var hiddenChillerInput = document.getElementById('add-chiller');
  var chillerModelCards = document.querySelectorAll('.c-chiller-card');
  var hiddenChillerModelInput = document.getElementById('chiller-model');
  var currentPath = window.location.pathname;
  var currentProductHandle = '';

  for (var i = 0; i < tubCards.length; i++) {
    if (currentPath === '/products/' + tubCards[i].dataset.handle) {
      tubCards[i].classList.add('active');
      currentProductHandle = tubCards[i].dataset.handle;
    }
  }


  var VARIANTS = {
    'the-polar-dive': { 'X1': '42792901509187', 'X2': '41525353971779', 'No': '41525354004547' },
    'the-polar-dive-pro': { 'X1': '42792947908675', 'X2': '41933171589187', 'No': '41933171621955' },
    'the-polar-dive-max': { 'X1': '42792947941443', 'X2': '41736761114691', 'No': '41736761147459' }
  };

  // Keep original PRICES but add compare at prices
  var PRICES = {
    'the-polar-dive': { 'X1': '$549.00 USD', 'X2': '$599.00 USD', 'No': '$119.00 USD' },
    'the-polar-dive-pro': { 'X1': '$899.00 USD', 'X2': '$1,049.00 USD', 'No': '$559.00 USD' },
    'the-polar-dive-max': { 'X1': '$949.00 USD', 'X2': '$1,099.00 USD', 'No': '$599.00 USD' }
  };


  // Add compare at prices data
  var COMPARE_AT_PRICES = {
    'the-polar-dive': { 'X1': '$1,168.00 USD', 'X2': '$1,168.00 USD', 'No': '$1,168.00 USD' },
    'the-polar-dive-pro': { 'X1': '$1,750.00 USD', 'X2': '$1,750.00 USD', 'No': '$799.00 USD' },
    'the-polar-dive-max': { 'X1': '$1,999.00 USD', 'X2': '$1,999.00 USD', 'No': '$999.00 USD' }
  };

  function selectChillerModel(modelKey) {
    if (!chillerModelCards.length) return;
    var normalized = (modelKey || '').toLowerCase();
    var fallbackCard = chillerModelCards[0];

    for (var i = 0; i < chillerModelCards.length; i++) {
      var card = chillerModelCards[i];
      var cardModel = (card.dataset.chillerModel || '').toLowerCase();
      if (cardModel === normalized) {
        fallbackCard = card;
        break;
      }
    }

    for (var j = 0; j < chillerModelCards.length; j++) {
      chillerModelCards[j].classList.remove('active');
      chillerModelCards[j].setAttribute('aria-pressed', 'false');
    }

    if (fallbackCard) {
      fallbackCard.classList.add('active');
      fallbackCard.setAttribute('aria-pressed', 'true');
      if (hiddenChillerModelInput) {
        var selectedModel = fallbackCard.dataset.chillerModel || 'x1';
        hiddenChillerModelInput.value = selectedModel;
        // Force update by triggering change event
        var changeEvent = new Event('change', { bubbles: true });
        hiddenChillerModelInput.dispatchEvent(changeEvent);
        // Also update the input directly to ensure it's set
        hiddenChillerModelInput.setAttribute('value', selectedModel);
      }
    }
  }

  function ensureDefaultChillerCard() {
    if (!chillerModelCards.length) return;
    if (!hiddenChillerModelInput || !hiddenChillerModelInput.value) {
      selectChillerModel(chillerModelCards[0].dataset.chillerModel);
      return;
    }
    selectChillerModel(hiddenChillerModelInput.value);
  }

  function getVariantKey(valueOverride) {
    var toggleValue = valueOverride || (hiddenChillerInput ? hiddenChillerInput.value : 'No');
    if (toggleValue === 'No' || !toggleValue) {
      return 'No';
    }
    var modelValue = hiddenChillerModelInput ? hiddenChillerModelInput.value : null;
    if (!modelValue) {
      return 'X1';
    }
    var normalizedModel = modelValue.toLowerCase();
    if (normalizedModel === 'x2') {
      return 'X2';
    }
    if (normalizedModel === 'x1') {
      return 'X1';
    }
    return 'Yes';
  }

  function refreshVariantAndPrice(valueOverride) {
    updateVariant(valueOverride);
    updatePrice(valueOverride);
    isInitialLoad = false;
    updateProductImages();
  }

  function updateProductImages(skipOnInitialLoad) {
    if (skipOnInitialLoad && isInitialLoad) {
      return;
    }

    // Wait a bit for variant change to take effect
    setTimeout(function () {
      // Get the current variant ID from the form
      var form = document.querySelector('form[action*="/cart/add"]');
      var variantInput = form ? form.querySelector('input[name="id"], select[name="id"]') : null;
      if (!variantInput) return;

      var currentVariantId = variantInput.value;

      // Get all gallery containers
      var allGalleries = document.querySelectorAll('.c-chiller-media-gallery');
      if (!allGalleries.length) return;

      // Hide all galleries first
      for (var i = 0; i < allGalleries.length; i++) {
        allGalleries[i].classList.add('c-chiller-media-gallery--hidden');
      }

      // Try to find gallery for current variant
      var targetGallery = document.querySelector('.c-chiller-media-gallery[data-variant-id="' + currentVariantId + '"]');

      if (targetGallery) {
        // Show custom images gallery for this variant
        targetGallery.classList.remove('c-chiller-media-gallery--hidden');
      } else {
        // Fallback: show default gallery (normal product images)
        var defaultGallery = document.querySelector('.c-chiller-media-gallery[data-variant-id="default"]');
        if (defaultGallery) {
          defaultGallery.classList.remove('c-chiller-media-gallery--hidden');
        }
      }

      // Update modal content with images from the visible gallery
      // Use a longer timeout to ensure product-info.js has finished updating the modal first
      setTimeout(function () {
        updateModalFromGallery();
      }, 300);
    }, 150);
  }

  function updateModalFromGallery() {
    // Find the visible gallery
    var visibleGallery = document.querySelector('.c-chiller-media-gallery:not(.c-chiller-media-gallery--hidden)');
    if (!visibleGallery) return;

    // Find the modal
    var modal = document.querySelector('product-modal');
    if (!modal) return;

    var modalContent = modal.querySelector('.product-media-modal__content');
    if (!modalContent) return;

    // Get all media items from the visible gallery (li elements with data-media-id)
    var galleryMediaItems = visibleGallery.querySelectorAll('li[data-media-id]');
    if (!galleryMediaItems.length) return;

    // Clear existing modal content
    modalContent.innerHTML = '';

    // Build modal content from gallery media items
    for (var i = 0; i < galleryMediaItems.length; i++) {
      var galleryItem = galleryMediaItems[i];
      var galleryMediaId = galleryItem.getAttribute('data-media-id');

      // Extract the actual media ID (remove section ID prefix)
      // Gallery format: "sectionId-suffix-mediaId", we need just the mediaId part
      var mediaIdParts = galleryMediaId.split('-');
      var actualMediaId = mediaIdParts[mediaIdParts.length - 1];

      // Find the media toggle button which has the correct data-media-id
      var mediaToggle = galleryItem.querySelector('button[data-media-id]');
      if (!mediaToggle) continue;

      var buttonMediaId = mediaToggle.getAttribute('data-media-id');

      // Find the image in the gallery item
      var mediaImg = galleryItem.querySelector('.product__media img');
      var mediaDeferred = galleryItem.querySelector('deferred-media[data-media-id], product-model[data-media-id]');

      if (mediaImg) {
        // Create modal image element matching product-media.liquid structure
        var modalImg = document.createElement('img');
        modalImg.className = 'global-media-settings global-media-settings--no-shadow';
        modalImg.setAttribute('data-media-id', buttonMediaId);

        // Copy srcset and src from gallery image, but use larger sizes for modal
        if (mediaImg.srcset) {
          modalImg.srcset = mediaImg.srcset;
        } else if (mediaImg.src) {
          // If no srcset, use the src and create a responsive srcset
          var baseSrc = mediaImg.src;
          // Remove any size parameters and create larger versions
          baseSrc = baseSrc.replace(/[?&]width=\d+/g, '').replace(/[?&]height=\d+/g, '');
          modalImg.srcset = baseSrc + '?width=550 550w, ' +
            baseSrc + '?width=1100 1100w, ' +
            baseSrc + '?width=1445 1445w, ' +
            baseSrc + '?width=1680 1680w, ' +
            baseSrc + '?width=2048 2048w';
        }

        modalImg.sizes = '(min-width: 750px) calc(100vw - 22rem), 1100px';
        modalImg.src = mediaImg.src || '';
        modalImg.alt = mediaImg.alt || '';
        modalImg.loading = 'lazy';
        modalImg.width = '1100';
        if (mediaImg.naturalHeight && mediaImg.naturalWidth) {
          modalImg.height = Math.round(1100 * (mediaImg.naturalHeight / mediaImg.naturalWidth));
        }

        modalContent.appendChild(modalImg);
      } else if (mediaDeferred) {
        // Clone deferred media element (videos, models) for modal
        var clonedDeferred = mediaDeferred.cloneNode(true);
        clonedDeferred.setAttribute('data-media-id', buttonMediaId);
        modalContent.appendChild(clonedDeferred);
      }
    }
  }

  function toggleChillerDetails(value) {
    if (!chillerDetails) return;
    if (value === 'Yes') {
      chillerDetails.classList.remove('is-hidden');
      chillerDetails.classList.remove('is-disabled');
      chillerDetails.removeAttribute('aria-hidden');
      ensureDefaultChillerCard();
      // Enable all chiller cards
      for (var i = 0; i < chillerModelCards.length; i++) {
        chillerModelCards[i].disabled = false;
        chillerModelCards[i].style.pointerEvents = '';
        chillerModelCards[i].style.opacity = '';
      }
    } else {
      chillerDetails.classList.remove('is-hidden');
      chillerDetails.classList.add('is-disabled');
      chillerDetails.setAttribute('aria-hidden', 'false');
      // Disable all chiller cards and remove active state
      for (var i = 0; i < chillerModelCards.length; i++) {
        chillerModelCards[i].classList.remove('active');
        chillerModelCards[i].setAttribute('aria-pressed', 'false');
        chillerModelCards[i].disabled = true;
        chillerModelCards[i].style.pointerEvents = 'none';
        chillerModelCards[i].style.opacity = '0.5';
      }
      if (hiddenChillerModelInput) {
        hiddenChillerModelInput.value = '';
      }
    }
  }

  function initializeChillerSelection() {
  if (!hiddenChillerInput) return;
  if (!currentProductHandle || !VARIANTS[currentProductHandle]) return;
  var form = document.querySelector('form[action*="/cart/add"]');
  var variantInput = form ? form.querySelector('input[name="id"]') : null;
  if (!variantInput) return;
  var variantMap = VARIANTS[currentProductHandle];

  // Honor an explicit ?variant= in the URL (feed links, ads, shared links).
  var urlVariant = new URLSearchParams(window.location.search).get('variant');
  var target = null;
  if (urlVariant === variantMap['X2']) target = 'X2';
  else if (urlVariant === variantMap['X1']) target = 'X1';
  else if (urlVariant === variantMap['No']) target = 'No';
  if (!target) target = 'X2'; // no/unknown variant param → Pro default, as today

  var yesCard = document.querySelector('#chiller-toggle .bundle-card[data-value="Yes"]');
  var noCard  = document.querySelector('#chiller-toggle .bundle-card[data-value="No"]');
  if (target === 'No') {
    if (noCard) noCard.classList.add('active');
    if (yesCard) yesCard.classList.remove('active');
    hiddenChillerInput.value = 'No';
    toggleChillerDetails('No');
  } else {
    if (yesCard) yesCard.classList.add('active');
    if (noCard) noCard.classList.remove('active');
    hiddenChillerInput.value = 'Yes';
    selectChillerModel(target.toLowerCase());
    toggleChillerDetails('Yes');
  }
  var allVariantInputs = document.querySelectorAll('input[name="id"], select[name="id"]');
  for (var i = 0; i < allVariantInputs.length; i++) {
    allVariantInputs[i].value = variantMap[target];
    allVariantInputs[i].dispatchEvent(new Event('change', { bubbles: true }));
  }
  refreshVariantAndPrice(hiddenChillerInput.value);
}

  function updateVariant(value) {
    if (!currentProductHandle || !VARIANTS[currentProductHandle]) return;
    var variantMap = VARIANTS[currentProductHandle];
    var variantKey = getVariantKey(value);
    var targetVariantId = variantMap[variantKey] || variantMap['X1'] || variantMap['No'];
    var allVariantInputs = document.querySelectorAll('input[name="id"], select[name="id"]');
    for (var i = 0; i < allVariantInputs.length; i++) {
      allVariantInputs[i].value = targetVariantId;
      var changeEvent = new Event('change', { bubbles: true });
      allVariantInputs[i].dispatchEvent(changeEvent);
    }
  }

  function updatePrice(value) {
    if (!currentProductHandle || !PRICES[currentProductHandle]) return;
    var priceKey = getVariantKey(value);
    var newPrice = PRICES[currentProductHandle][priceKey] || PRICES[currentProductHandle]['X1'];
    var compareAtPrice = COMPARE_AT_PRICES[currentProductHandle]
      ? (COMPARE_AT_PRICES[currentProductHandle][priceKey] || COMPARE_AT_PRICES[currentProductHandle]['X1'])
      : null;

    // Wait a bit for the variant change to take effect
    setTimeout(function () {
      // Try to find the main product price section first
      var priceContainer = document.querySelector('#price-template--17773399507011__main') ||
        document.querySelector('[id*="price-template"]') ||
        document.querySelector('.price.price--large') ||
        document.querySelector('.price') ||
        document.querySelector('[class*="price"]') ||
        document.querySelector('.product-price') ||
        document.querySelector('.price-container');

      if (!priceContainer) {
        // Fallback: try to find any element containing a price
        var allElements = document.querySelectorAll('*');
        for (var k = 0; k < allElements.length; k++) {
          var element = allElements[k];
          if (element.textContent && element.textContent.includes('$') && element.textContent.includes('USD')) {
            element.textContent = newPrice;
            return;
          }
        }
        return;
      }

      // Check if this is a simple price element (like the one we found)
      if (priceContainer.classList.contains('price') && !priceContainer.querySelector('.price__regular, .price__sale')) {
        priceContainer.textContent = newPrice;
        return;
      }

      // Handle the specific price structure you showed me
      if (priceContainer.querySelector('.price__container')) {
        if (compareAtPrice) {
          // Show sale price with compare at
          var regularPriceElement = priceContainer.querySelector('.price__regular .price-item--regular');
          var salePriceElement = priceContainer.querySelector('.price__sale .price-item--sale');
          var compareAtElement = priceContainer.querySelector('.price__sale .price-item--regular');

          // Update compare at price (the crossed out price in sale section)
          if (compareAtElement) {
            compareAtElement.textContent = compareAtPrice;
          }

          // Update sale price
          if (salePriceElement) {
            salePriceElement.textContent = newPrice;
          }

          // Hide regular price section, show sale price section
          var regularSection = priceContainer.querySelector('.price__regular');
          var saleSection = priceContainer.querySelector('.price__sale');
          if (regularSection) regularSection.style.display = 'none';
          if (saleSection) saleSection.style.display = 'block';

        } else {
          // Show regular price only
          var regularPriceElement = priceContainer.querySelector('.price__regular .price-item--regular');

          if (regularPriceElement) {
            regularPriceElement.textContent = newPrice;
          }

          // Hide sale price section, show regular price section
          var regularSection = priceContainer.querySelector('.price__regular');
          var saleSection = priceContainer.querySelector('.price__sale');
          if (saleSection) saleSection.style.display = 'none';
          if (regularSection) regularSection.style.display = 'block';
        }

        return;
      }

      // Fallback for other price structures
      if (compareAtPrice) {
        // Show sale price with compare at
        var regularPriceElement = priceContainer.querySelector('.price__regular .price-item--regular') ||
          priceContainer.querySelector('.price-item--regular') ||
          priceContainer.querySelector('[class*="regular"]');
        var salePriceElement = priceContainer.querySelector('.price__sale .price-item--sale') ||
          priceContainer.querySelector('.price-item--sale') ||
          priceContainer.querySelector('[class*="sale"]');
        var compareAtElement = priceContainer.querySelector('.price__sale .price-item--regular') ||
          priceContainer.querySelector('[class*="compare"]');

        // Update compare at price (the crossed out price in sale section)
        if (compareAtElement) {
          compareAtElement.textContent = compareAtPrice;
        }

        // Update sale price
        if (salePriceElement) {
          salePriceElement.textContent = newPrice;
        }

        // Hide regular price section, show sale price section
        var regularSection = priceContainer.querySelector('.price__regular');
        var saleSection = priceContainer.querySelector('.price__sale');
        if (regularSection) regularSection.style.display = 'none';
        if (saleSection) saleSection.style.display = 'block';

      } else {
        // Show regular price only
        var regularPriceElement = priceContainer.querySelector('.price__regular .price-item--regular') ||
          priceContainer.querySelector('.price-item--regular') ||
          priceContainer.querySelector('[class*="regular"]');

        if (regularPriceElement) {
          regularPriceElement.textContent = newPrice;
        } else {
          // Fallback: update the container itself
          priceContainer.textContent = newPrice;
        }

        // Hide sale price section, show regular price section
        var regularSection = priceContainer.querySelector('.price__regular');
        var saleSection = priceContainer.querySelector('.price__sale');
        if (saleSection) saleSection.style.display = 'none';
        if (regularSection) regularSection.style.display = 'block';
      }
    }, 200);
  }

  function handleChillerSelection(card) {
    if (!hiddenChillerInput) return;
    for (var j = 0; j < chillerToggle.length; j++) {
      chillerToggle[j].classList.remove('active');
    }
    card.classList.add('active');
    var value = card.dataset.value;
    hiddenChillerInput.value = value;
    toggleChillerDetails(value);
    setTimeout(function () {
      refreshVariantAndPrice(value);
    }, 100);
  }

  for (var i = 0; i < chillerToggle.length; i++) {
    (function (card) {
      card.addEventListener('click', function () {
        handleChillerSelection(card);
      });

      card.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          handleChillerSelection(card);
        }
      });
    })(chillerToggle[i]);
  }

  for (var l = 0; l < chillerModelCards.length; l++) {
    (function (card) {
      card.addEventListener('click', function () {
        if (chillerDetails && chillerDetails.classList.contains('is-disabled')) {
          return;
        }
        var modelValue = card.dataset.chillerModel || 'x1';
        selectChillerModel(modelValue);
        // Ensure the hidden input is updated immediately
        if (hiddenChillerModelInput) {
          hiddenChillerModelInput.value = modelValue;
          hiddenChillerModelInput.setAttribute('value', modelValue);
        }
        refreshVariantAndPrice();
      });

      card.addEventListener('keydown', function (event) {
        if (chillerDetails && chillerDetails.classList.contains('is-disabled')) {
          return;
        }
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          var modelValue = card.dataset.chillerModel || 'x1';
          selectChillerModel(modelValue);
          // Ensure the hidden input is updated immediately
          if (hiddenChillerModelInput) {
            hiddenChillerModelInput.value = modelValue;
            hiddenChillerModelInput.setAttribute('value', modelValue);
          }
          refreshVariantAndPrice();
        }
      });
    })(chillerModelCards[l]);
  }

  // Ensure hidden input value is synced before form submission
  var productForm = document.querySelector('form[action*="/cart/add"]');
  if (productForm && hiddenChillerModelInput) {
    productForm.addEventListener('submit', function (event) {
      // Ensure the chiller model value is up to date before submission
      var activeChillerCard = document.querySelector('.c-chiller-card.active[data-chiller-model]');
      if (activeChillerCard && hiddenChillerModelInput) {
        var currentModel = activeChillerCard.dataset.chillerModel || 'x1';
        hiddenChillerModelInput.value = currentModel;
        hiddenChillerModelInput.setAttribute('value', currentModel);
      }
    }, false);
  }
  var initialToggleValue = hiddenChillerInput && hiddenChillerInput.value ? hiddenChillerInput.value : 'No';
  // Run immediately to set Pro (X2) as default before any other script can override
  initializeChillerSelection();
  toggleChillerDetails(initialToggleValue);
  // Re-run after delay to override any late-loading scripts that may reset variant
  setTimeout(initializeChillerSelection, 100);
  setTimeout(initializeChillerSelection, 500);
  // Don't call updateProductImages on initial load - Liquid already renders the correct gallery
  // This prevents flicker. The function will only run when variant changes via refreshVariantAndPrice()

  // Mark initial load as complete after a short delay to allow any variant change events to set the flag
  setTimeout(function () {
    updateProductImages(false); // runs with the *current* variantId
    isInitialLoad = false;
  }, 300);
});

